module.exports = __webpack_public_path__ + "img/delete_icon.fd1b666a.svg";